import { useId } from 'react';
import { Card, CardContent, CardTitle } from '@/shared/components';
import type { DocumentTemplateDetail } from '../../types/documentTemplates.types';
import { formatDay } from '../../utils/versionLabels';
import { DealerNamePlaceholder } from '../DealerNamePlaceholder';

interface Props {
  template: DocumentTemplateDetail;
  /** Null while the dealer name is loading. */
  ownerName: string | null;
}

export function RecordCard({ template, ownerName }: Props) {
  const headingId = useId();
  const rows = [
    { label: 'Owner', value: ownerName ?? <DealerNamePlaceholder /> },
    { label: 'Created', value: formatDay(template.createdAt) },
    { label: 'Last updated', value: formatDay(template.updatedAt) },
  ];

  return (
    <Card ariaLabelledBy={headingId}>
      <CardContent className="space-y-3 py-5">
        <CardTitle size="sm" id={headingId}>
          Record
        </CardTitle>
        <dl className="grid grid-cols-3 gap-x-3 gap-y-2.5 text-sm">
          {rows.map((row) => (
            <div key={row.label} className="contents">
              <dt className="text-mp-muted">{row.label}</dt>
              <dd className="col-span-2">{row.value}</dd>
            </div>
          ))}
          <dt className="text-mp-muted">Template ID</dt>
          <dd className="col-span-2 font-mono text-xs break-all">{template.id}</dd>
        </dl>
      </CardContent>
    </Card>
  );
}
